module.exports = __webpack_public_path__ + "static/36-12n-379o-01-28a930542a87e73bf5d3ee19473e2c46.jpg";